/**
 * Pendaftaran service worker (spec CP12). Hanya di build produksi: dev (HMR)
 * dan unit test (jsdom) tidak mendaftarkan SW. Pendaftaran yang gagal tidak
 * boleh naik ke console sebagai error — aplikasi tetap jalan tanpa SW.
 */
export const SW_URL = '/sw.js';

export async function registerServiceWorker(): Promise<void> {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  try {
    await navigator.serviceWorker.register(SW_URL, { type: 'module' });
  } catch {
    // Gagal daftar (mis. storage dimatikan pengguna): fitur offline hilang,
    // aplikasi tetap berfungsi — bukan alasan crash.
  }
}
